/**
 * Created by jinbian on 08/11/2017.
 */
import React from "react";
import "./_index.scss";
import Header from "../../Components/Header/index";
import Footer from "../../Components/Footer/index";
import Page404 from "../../Components/Page404";
import Site from "./Site";
import Doc from "./Doc";

export default class extends React.Component {
    state = {
      error: false,
    }

    onError = () => {
      this.setState({ error: true });
    }

    render() {

        const { projectType, projectID, projectStatus } = this.props.params;

        let setting = null;

        if (projectID && window.PUBHUB_PATH_LIST) {
            const target = Object.values(window.PUBHUB_PATH_LIST).find((item) => item.id === parseInt(projectID));
            if (target && target.setting) {
                try {
                    setting = JSON.parse(target.setting);
                } catch (e) {
                    console.error(e);
                }
            }
        }

        let content = null;

        // if pubhub preview feature is not allowed(e.g. production environment), redirect to homepage
        if ((!window["PREVIEW_PUBHUB_PROJECT"])
            && this.props.location.pathname.startsWith("/pubhub/")) {
            window.location = "/"
            return null;
        }

        if (projectType === "site") {
            content = <Site projectType={projectType} 
            projectID={projectID} 
            projectStatus={projectStatus} 
            onError={this.onError} />
        } else if (projectType === "docs") {
            content = <Doc projectType={projectType} 
            projectID={projectID} 
            projectStatus={projectStatus} 
            />
        }

        let header = <Header setting={setting} />;

        content = this.state.error ? (
          <Page404 />
        ) : content;

        return (
            <div>
                {header}
                {content}
                <Footer setting={setting} />
            </div>
        )
    }
}